export default "__VITE_ASSET__CaZ8eHPc__"